<div
  class="text-widget"
  [class.no-wrap]="!wrapEnabled && !shouldClamp"
  [class.clamp]="shouldClamp"
  [style.display]="shouldClamp ? '-webkit-box' : 'block'"
  [style.webkit-box-orient]="shouldClamp ? 'vertical' : null"
  [style.webkitLineClamp]="shouldClamp ? maxLines : null"
  [style.white-space]="shouldClamp ? 'normal' : (wrapEnabled ? 'normal' : 'nowrap')"
  [style.word-break]="'break-word'"
  [style.overflow-wrap]="'anywhere'"
  [style.max-width]="'100%'"
  [style.min-width]="'0'"
  [style.text-overflow]="overflowMode"
  [style.color]="color"
  [style.text-align]="textAlign"
  [style.font-size]="fontSize"
  [style.font-weight]="fontWeight"
  [style.font-style]="fontStyle"
  [style.font-family]="fontFamily"
  [style.line-height]="lineHeight"
  [style.letter-spacing]="letterSpacing"
>
  {{ text }}
</div>
